const isFunction = (fn: any) => typeof fn === 'function';

export interface SubscriptionLike {
  unsubscribe(): void;
}

export class SubSink {
  protected subs: SubscriptionLike[] = [];

  add(..._subs: SubscriptionLike[]): void {
    this.subs = this.subs.concat(_subs);
  }

  set sink(_sub: SubscriptionLike) {
    this.subs.push(_sub);
  }

  unsubscribe(): void {
    this.subs.forEach(_sub => _sub && isFunction(_sub.unsubscribe) && _sub.unsubscribe());
    this.subs = [];
  }
}
